/* Baby Basket — search sheet with typing placeholder and live product results. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const sheet = $('[data-search]');
  if (!sheet) return;
  const BB = window.BB || { routes: {} };
  const root = (BB.routes.root || '/').replace(/\/?$/, '/');
  const input = $('[data-search-input]', sheet);
  const word = $('[data-search-word]', sheet);
  const start = $('[data-search-start]', sheet);
  const results = $('[data-search-results]', sheet);
  const words = (sheet.dataset.words || '').split('|').filter(Boolean);
  const money = sheet.dataset.money || '{amount}';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Open / close ---------- */
  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-search');
    setTimeout(() => input.focus(), 60);
    typeLoop();
  };
  const close = () => {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('has-search');
    clearTimeout(typer);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('is-open')) close();
    const typing = /input|textarea|select/i.test(document.activeElement.tagName) || document.activeElement.isContentEditable;
    if (e.key === '/' && !typing && !sheet.classList.contains('is-open')) { e.preventDefault(); open(); }
  });

  /* ---------- Placeholder that types product ideas ---------- */
  let typer;
  let wi = 0;
  const typeLoop = () => {
    clearTimeout(typer);
    if (!words.length || !sheet.classList.contains('is-open')) return;
    if (reduced) { word.textContent = words[0]; return; }
    const w = words[wi % words.length];
    let i = 0;
    let back = false;
    const step = () => {
      if (!sheet.classList.contains('is-open')) return;
      word.textContent = w.slice(0, i);
      if (!back && i < w.length) { i += 1; typer = setTimeout(step, 85); }
      else if (!back) { back = true; typer = setTimeout(step, 1400); }
      else if (i > 0) { i -= 1; typer = setTimeout(step, 40); }
      else { wi += 1; typer = setTimeout(typeLoop, 250); }
    };
    step();
  };

  /* ---------- Live results (Shopify predictive search) ---------- */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const mark = (text, q) => {
    const safe = esc(text);
    const term = q.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return term ? safe.replace(new RegExp(`(${esc(term)})`, 'ig'), '<mark>$1</mark>') : safe;
  };
  const price = (p) => money.replace(/\{\{\s*\w+\s*\}\}|\{amount\}/, Number(p).toFixed(2));
  const img = (p) => {
    const src = (p.featured_image && p.featured_image.url) || p.image;
    if (!src) return '';
    const url = src.includes('?') ? `${src}&width=160` : `${src}?width=160`;
    return `<img src="${esc(url)}" alt="" loading="lazy" width="72" height="72">`;
  };

  let timer;
  let ctrl;
  const render = (q, products) => {
    const all = `${root}search?q=${encodeURIComponent(q)}&type=product`;
    if (!products.length) {
      results.innerHTML = `<div class="bb-search__empty"><span>${esc(sheet.dataset.none)}</span></div>`;
      return;
    }
    results.innerHTML = `<div class="bb-search__list">${products.map((p, i) => `
      <a class="bb-search__item" href="${esc(p.url)}" style="animation-delay:${i * 40}ms">
        <span class="bb-search__thumb">${img(p)}</span>
        <span><span class="bb-search__name">${mark(p.title, q)}</span>
          ${p.vendor && p.vendor !== 'Baby Basket' ? `<span class="bb-search__vendor">${esc(p.vendor)}</span>` : ''}
          ${p.available ? '' : `<span class="bb-search__sold">${esc(sheet.dataset.sold)}</span>`}</span>
        <span class="bb-search__price">${Number(p.price) > 0 ? esc(price(p.price)) : ''}</span>
      </a>`).join('')}</div>
      <a class="bb-search__all" href="${all}">${esc(sheet.dataset.all)} “${esc(q)}”<svg class="icon icon--flip" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>`;
  };
  const search = (q) => {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    results.innerHTML = '<div class="bb-search__loading" aria-hidden="true"><span></span><span></span><span></span></div>';
    const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=9&resources[options][unavailable_products]=last`;
    fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((d) => render(q, (d.resources && d.resources.results && d.resources.results.products) || []))
      .catch((err) => { if (err.name !== 'AbortError') results.innerHTML = ''; });
  };
  input.addEventListener('input', () => {
    const q = input.value.trim();
    sheet.classList.toggle('has-text', input.value.length > 0);
    start.hidden = q.length > 0;
    results.hidden = q.length === 0;
    clearTimeout(timer);
    if (q.length) timer = setTimeout(() => search(q), 180);
  });
})();
